import { SelectOption } from '@globaleris/ui.library'
import {
  AtlasUserModel,
  FilterTaskRequest,
  TaskModel,
  TaskPatchModel,
  TaskPostModel,
  TaskTableModel,
  TaskTypeModel
} from '../../api/Argentia/endpoints/tasks/model/tasks'
import { EnumCriticidad } from '../../api/oData/enums/enumCriticidad'
import { EnumDominioTarea } from '../../api/oData/enums/enumDominioTarea'
import { formatDateOnlyString, formatDateOnlyStringWithTime } from '../../helpers/formatDateOnly'
import { DateFilters } from '../../model'
import { getTaskModelRelatedEntityValue } from './task.helpers'
import { TaskAddEditFormModel, TaskTypeSelectOption } from './tasks.model'

export const mapTaskFormSearchToFilterRequest = (
  startDate?: Date | null,
  endDate?: Date | null,
  taskType?: EnumDominioTarea[] | number[],
  criticality?: EnumCriticidad[] | number[],
  activeTab?: number
): FilterTaskRequest => {
  let request: FilterTaskRequest = {
    taskType: taskType && taskType.length > 0 ? [...taskType] : undefined,
    criticality: criticality && criticality.length > 0 ? [...criticality] : undefined,
    taskState: [activeTab!],
    startDate: startDate,
    endDate: endDate
  }

  if (!startDate && !endDate) {
    request.top200results = true
  }

  return request
}

export const mapTaskTypeResponseToSelectOptionArray = (
  taskTypes: TaskTypeModel[]
): TaskTypeSelectOption[] => {
  return taskTypes.map(taskType => mapTaskTypeResponseToSelectOption(taskType))
}

export const mapTaskTypeResponseToSelectOption = (
  taskType: TaskTypeModel
): TaskTypeSelectOption => {
  return {
    value: taskType.id,
    label: taskType.description,
    code: taskType.code,
    description: taskType.description,
    criticality: taskType.criticality
  }
}

export const mapTaskModelToTaskEditForm = (task: TaskModel): TaskAddEditFormModel => {
  const value = getTaskModelRelatedEntityValue(task)
  return {
    ...task,
    relatedEntityCode: value && value[0]
  }
}

export const mapUsersToSelectOptionArray = (users: string[]): SelectOption[] => {
  return users.map(user => mapUserToSelectOption(user))
}

export const mapUserToSelectOption = (user: string): SelectOption => {
  return {
    value: user,
    label: user
  }
}

export const mapAtlasUsersToSelectOptionArray = (users: AtlasUserModel[]): SelectOption[] => {
  return users.map(user => ({
    value: user.email,
    label: `${user.authorNameAtlas} (${user.email})`
  }))
}

export const mapTaskEditFormModelToTaskPatchModel = (
  task: TaskAddEditFormModel
): TaskPatchModel => {
  return {
    id: task.id,
    description: task.description,
    assignedUser: task.assignedUser,
    authorNameAtlas: task.authorNameAtlas || null,
    criticality: task.criticality,
    status: task.status,
    closingDate: formatDateOnlyString(task.closingDate),
    comments: task.comments,
    relatedEntityId: task.relatedEntityId
  }
}

export const mapTaskAddFormModelToTaskPostModel = (
  task: TaskAddEditFormModel,
  companyId: number
): TaskPostModel => {
  return {
    description: task.description,
    assignedUser: task.assignedUser,
    authorNameAtlas: task.authorNameAtlas || null,
    criticality: task.criticality,
    status: task.status,
    closingDate: formatDateOnlyString(task.closingDate),
    companyId: companyId,
    taskType: {
      id: +task.taskType.id
    }
  }
}

export const mapTaskFilterRequest = (
  startDate: Date,
  endDate: Date,
  activeDateFilter: DateFilters | undefined,
  activeTab: number
): FilterTaskRequest => {
  let request: FilterTaskRequest = {
    taskState: [activeTab]
  }

  if (activeDateFilter === DateFilters.RECORDS_LIM_200) {
    request.top200results = true
  } else {
    request.startDate = startDate
    request.endDate = endDate
  }

  return request
}

export const mapResponseDataToTaskTableModel = (data: TaskModel[]): TaskTableModel[] => {
  return data.map(item => ({
    ...item,
    creationDate: formatDateOnlyStringWithTime(item.creationDate) ?? '',
    closingDate: formatDateOnlyStringWithTime(item.closingDate)
  }))
}
